import CalendarLtrFilled from 'mini-fluent-svg-icons/lib/icons/CalendarLtrFilled';
import CalendarLtrRegular from 'mini-fluent-svg-icons/lib/icons/CalendarLtrRegular';
import MailFilled from 'mini-fluent-svg-icons/lib/icons/MailFilled';
import MailRegular from 'mini-fluent-svg-icons/lib/icons/MailRegular';
import type Module from 'mini-common-schema/lib/schema/Module';
import PeopleFilled from 'mini-fluent-svg-icons/lib/icons/PeopleFilled';
import PeopleRegular from 'mini-fluent-svg-icons/lib/icons/PeopleRegular';
import RewardsFilled from 'mini-fluent-svg-icons/lib/custom-icons/RewardsFilled';
import RewardsRegular from 'mini-fluent-svg-icons/lib/custom-icons/RewardsRegular';
import styles from '../components/MiniModuleSwitcher.scss';
import { format } from 'owa-strings/utilities/format';
import { getDate, today } from 'owa-datetime';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { isRewardsFeatureEnabled } from 'mini-rewards-utils/lib/utils/isRewardsFeatureEnabled';
import { lazyLogRewardsIconClicked } from 'mini-rewards-telemetry';
import type ModuleSwitcherItem from '../schema/ModuleSwitcherItem';

export interface ModuleSwitcherIconRefs {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    mailIconRef?: React.RefObject<any>;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    calendarIconRef?: React.RefObject<any>;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    peopleIconRef?: React.RefObject<any>;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    rewardsIconRef?: React.RefObject<any>;
}

/**
 * Utility to get the items with their properties to be shown in the footer of the reading pane
 */
export default function getModuleSwitcherItems(
    iconRefs: ModuleSwitcherIconRefs,
    currentModule?: Module
): ModuleSwitcherItem[] {
    const strings = getOwaMiniCommonStrings();
    const { mailIconRef, calendarIconRef, peopleIconRef, rewardsIconRef } = iconRefs || {};

    return [
        {
            moduleType: 0,
            icon: currentModule === 0 ? MailFilled : MailRegular,
            label: strings.moduleMailLabel,
            ariaLabel: strings.moduleMailAriaLabel,
            ariaLabelWhenSelected: strings.moduleMailSelectedAriaLabel,
            iconRef: mailIconRef,
        },
        {
            moduleType: 1,
            icon: currentModule === 1 ? CalendarLtrFilled : CalendarLtrRegular,
            label: strings.moduleCalendarLabel,
            ariaLabel: format(strings.moduleCalendarAriaLabel, getDate(today())),
            ariaLabelWhenSelected: format(
                strings.moduleCalendarSelectedAriaLabel,
                getDate(today())
            ),
            iconRef: calendarIconRef,
        },
        {
            moduleType: 2,
            icon: currentModule === 2 ? PeopleFilled : PeopleRegular,
            label: strings.modulePeopleLabel,
            ariaLabel: strings.modulePeopleAriaLabel,
            ariaLabelWhenSelected: strings.modulePeopleSelectedAriaLabel,
            iconRef: peopleIconRef,
        },
        isRewardsFeatureEnabled() && {
            moduleType: 3,
            icon: currentModule === 3 ? RewardsFilled : RewardsRegular,
            iconStyles: styles.rewardsIconStyle,
            label: strings.moduleRewardsLabel,
            ariaLabel: strings.moduleRewardsAriaLabel,
            ariaLabelWhenSelected: strings.moduleRewardsSelectedAriaLabel,
            iconRef: rewardsIconRef,
            onModuleClick: () => {
                lazyLogRewardsIconClicked.importAndExecute();
            },
        },
    ].filter(Boolean); // Remove falsy values
}
